import { ReactNode } from 'react';
import { Button as MuiButton, Stack, SxProps, Theme } from '@mui/material';

type ButtonProps = {
  children: ReactNode;
  onClick: () => void;
  type: 'primary' | 'accent';
  size?: 'small' | 'normal';
  center?: boolean;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
};

export const ButtonText: React.FC<ButtonProps> = ({
  children,
  onClick,
  type,
  size = 'normal',
  sx,
  center,
  fullWidth = true,
}) => {
  const accentStyles = {
    color: 'var(--color-accent)',
    '&:hover': {
      opacity: 0.9,
    },
  };

  return (
    <Stack direction="row" justifyContent={center ? 'center' : 'flex-start'}>
      <MuiButton
        variant="text"
        color="primary"
        onClick={onClick}
        sx={{
          ...(type === 'accent' ? accentStyles: {color: 'var(--color-primary)'}),
          padding: size === 'small' ? '12px 16px' : '16px',
          ...(fullWidth && { width: '100%', maxWidth: '500px' }),
          ...sx,
        }}
      >
        {children}
      </MuiButton>
    </Stack>
  );
};
